import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ExtractionRuleEffects } from './extraction-rule.effects';
import { reducer, initialState } from './extraction-rule.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { ExtractionRuleState } from './extraction-rule.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<ExtractionRuleState>({
  keys: ['sectionSizes'],
  rehydrate: true,
  storage: sessionStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-extractionRule-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('extractionRule', reducer, {
      initialState,
      metaReducers: [syncMetaReducer],
    }),
    EffectsModule.forFeature([ExtractionRuleEffects]),
  ],
  providers: [ExtractionRuleEffects],
})
export class ExtractionRuleStoreModule {}
